import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "src/uicomponents/components/extable/serverFilteringTable";
import { currency, CurrencyManipulationViewModel } from "./currencyManipulation-viewModel"

export class CurrencyManipulationView extends View<CurrencyManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-1F4537A6-BC10-43D7-AB74-94967DB05F7C"
    }
    loadHtml(): string {
        let element = require('./currencyManipulation.html').default;
        let style = require('./currencyManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set currencies(v: ObservableArray<currency>) { this._currencies = v; } public get currencies(): ObservableArray<currency> { return this._currencies;} private _currencies: ObservableArray<currency>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    

    requestCurrencyCreation(){
        this.dataContext.requestCurrencyCreation();
    }
}
